import {gsap} from "gsap";
import {ScrollSmoother} from "gsap/ScrollSmoother";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollSmoother, ScrollTrigger);

let smoother;

function smootherSetup() {
    if (!ScrollTrigger.isTouch) {
        smoother = ScrollSmoother.create({
            wrapper: '#smooth-wrapper',
            content: '.site-content',
            smooth: 1.3,
            effects: true,
            normalizeScroll: true,
            ignoreMobileResize: true
        });
    }
}

document.addEventListener('DOMContentLoaded', (event) => {
    smootherSetup();
});

// anchor links
window.addEventListener("load", (e) => {
    if (window.location.hash) {
        console.log(window.location.hash);
      ScrollSmoother.get().scrollTo(window.location.hash, true);
    }
});

export { smootherSetup, smoother };